export default class Business {

    marketplace_general_administrator_role() {
        return "FRONTOFFICE_GENERAL_ADMINISTRATOR_ROLE"
    }

    marketplace_administrative_role() {
        return "FRONTOFFICE_ADMINISTRATIVE_ROLE"
    }

    marketplace_operational_role() {
        return "FRONTOFFICE_OPERATIONAL_ROLE"
    }
}